import _ from 'lodash';

// The RAS gateway only knows its users by email. The company users supply the profile (name) and
// the IAM id the Edit modal needs, so the two lists are joined on email. A gateway user without a
// company user is left out, as it always was.
export const buildMachineUsersDetails = (machineUsers, companyUsers) => {
	return _.compact(
		companyUsers.map((companyUser) => {
			const machineUser = machineUsers.find((machineUser) => { return machineUser.email === companyUser.email; });

			if (machineUser) {
				return {
					...companyUser,
					allowedDestinations: machineUser.allowedDestinations,
				};
			}
		})
	);
};

// When the company users are not available to the caller there is nothing to join with: every
// gateway user is listed with its email only and `profile: null`, which the tab renders read-only.
export const buildGatewayUsersWithoutProfile = (machineUsers) => {
	return machineUsers.map((machineUser) => {
		return { email: machineUser.email, allowedDestinations: machineUser.allowedDestinations, profile: null };
	});
};

// The "Grant Access" candidates: company users that are not yet users of the gateway.
export const buildUnassignedUserOptions = (companyUsers, machineUsers) => {
	return _.differenceBy(companyUsers, machineUsers, 'email').map((unassignedUser) => {
		return {
			label: `${unassignedUser.profile.firstName} ${unassignedUser.profile.lastName}`,
			value: unassignedUser.email,
			id: unassignedUser.id,
		};
	});
};
